import React from 'react'
import { connect } from 'react-redux';

import { Show, SimpleShowLayout } from 'components/detail'
import { TextField } from 'components/field'
import { ActionButton } from 'components/button'

import * as urls from './urls'
import * as utils from './utils'
import FunctionField from "../../components/field/FunctionField";
import FileField from "../../components/field/FileField";
import ImageField from "../../components/field/ImageField";

import { crudUpdate as crudUpdateAction } from 'actions/dataActions';
import { retryFailed } from './NotificationList';


export const NotificationDetail = (props) => {
  return (
    <Show 
      editBackendPath={urls.notificationEditBackendPath}
      detailBackendPath={urls.notificationDetailBackendPath}
      {...props}
    >
      <SimpleShowLayout>
        <TextField source="id" label="ID"/>
        <FunctionField label="Notification type" render={record => `${utils.MESSAGE_TYPE_NAME[record.message_type]}`} />
        <ImageField source="image" label="Image" />
        <TextField source="title" label="Title"/>
        <TextField source="body" label="Body"/>
        <FunctionField label="Target App" render={record => `${utils.APP_TYPE_NAME[record.app_type]}`} />
        <TextField source="url" label="URL / In App page"/>
        <FunctionField label="Target Users" render={record => `${utils.SEND_TYPE_NAME[record.send_type]}`} />
        <FileField source="shop_ids_file_path" title='List of uid' label="List of uid" />
        <FunctionField label="Delivery type" render={record => `${utils.NOTIFICATION_DELIVER_TYPE_NAME[record.delivery_type]}`} />
        <TextField source="delivery_time" label="Delivery Time"/>
        <TextField source="last_updated_by" label="Last Updated By"/>
        <FunctionField 
          source="status_display" 
          label="Status" 
          render={(record) => {
            let custom_status_display = record.status_display || '-';
            if (
              record.status === utils.NOTIFICATION_STATUS_FAILED
            ) {
              const _props = {
                ...props,
                basePath: '/notification',
                record: record,
              };
              custom_status_display = (<span>
                {`${record.status_display} (${record.success_ratio || '-/-'} sent)`}
                <br />
                <ActionButton 
                  {..._props}
                  is_raised={true}
                  label="Retry"
                  action={() => { return retryFailed(_props); }}
                />
              </span>);
            }

            return custom_status_display;
          }}
        />
      </SimpleShowLayout>
    </Show>
  )
};

export default connect(
  null,
  {
    crudUpdate: crudUpdateAction,
  }
)(NotificationDetail);



// WEBPACK FOOTER //
// ./src/routes/notification/NotificationDetail.js